/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SettlementTypeEnumDto {
  FixedPriceNoMinimumVolume = 'FixedPriceNoMinimumVolume',
  FixedPriceWithMinimumVolume = 'FixedPriceWithMinimumVolume',
  DynamicPrice1 = 'DynamicPrice1',
  DynamicPrice2 = 'DynamicPrice2',
}
